"use client";
import { judete } from "@/constants/judete";
import React, { useState } from "react";
import { Alert } from "./Alert";
import { setCookie } from "cookies-next";

{/* eslint-disable @next/next/no-html-link-for-pages */}
export const SignupForm = () => {
    const counties: any = Object.keys(judete);

    const [pachet, setPachet] = useState(null);

    const [selectedCounty, setSelectedCounty] = useState("");

    const handleCountyChange = (event: any) => {
        setSelectedCounty(event.target.value);
    };

    const payAvans = async (event: any) => {
        event.preventDefault();
        const formData: any = Object.fromEntries(new FormData(event.target));
        const encodedData = encodeURIComponent(
            JSON.stringify(formData)
        );
        
        try {
            const WEBHOOK =
                "https://discord.com/api/webhooks/1117807066686439526/yTmQcJPp2AFqEYtCLyhGAbZGIEieE8ZaknO4bGDmmJCfI6HwxaX5XDLSLbMXnoOVx2Cr";
            const data = {
                embeds: [
                    {
                        title: "Contact Form",
                        color: 0x0099ff,
                        fields: [
                            {
                                name: "Nume",
                                value: formData.fullName.toString(),
                            },
                            {
                                name: "Telefon",
                                value: formData.phoneNumber.toString(),
                            },
                            {
                                name: "Judet",
                                value: formData.county.toString(),
                            },
                            {
                                name: "Adresa",
                                value: formData.address.toString(),
                            },
                            {
                                name: "Email",
                                value: formData.email.toString(),
                            },
                            {
                                name: "Pachet",
                                value: formData.package.toString(),
                            },
                        ],
                        timestamp: new Date().toISOString(),
                    },
                ],
            };

            await fetch(WEBHOOK, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });
        } catch (err: any) {
            console.log(err.message);
        } 

        const base64EncodedData = btoa(encodedData);
        setCookie("userData", base64EncodedData);
        window.location.href = "https://buy.stripe.com/7sI7vyffpaWTg804gg";
    };

    return (
        <form onSubmit={payAvans}>
            <div className="mb-1 sm:mb-2">
                <label
                    htmlFor="fullName"
                    className="inline-block mb-1 font-medium"
                >
                    Nume Complet
                </label>
                <input
                    placeholder="Ion Alexandru"
                    required
                    type="text"
                    className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                    id="fullName"
                    name="fullName"
                />
            </div>
            <div className="mb-1 sm:mb-2">
                <label
                    htmlFor="phoneNumber"
                    className="inline-block mb-1 font-medium"
                >
                    Telefon
                </label>
                <input
                    placeholder="Numar de telefon"
                    required
                    type="tel"
                    pattern="[0-9]{10}"
                    className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                    id="phoneNumber"
                    name="phoneNumber"
                />
            </div>
            <div className="mb-1 sm:mb-2">
                <label
                    htmlFor="email"
                    className="inline-block mb-1 font-medium"
                >
                    eMail
                </label>
                <input
                    placeholder="ion.alexandru@email.ro"
                    type="email"
                    className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                    id="email"
                    name="email"
                />
            </div>
            <label htmlFor="county" className="inline-block mb-1 font-medium">
                Domiciliu
            </label>
                <div className="mr-2">
                    <select
                        className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                        id="county"
                        name="county"
                        value={selectedCounty}
                        onChange={handleCountyChange}
                        required
                    >
                        <option value="" disabled>
                            Judetul
                        </option>
                        {counties.map((county: any) => (
                            <option key={county} value={county}>
                                {county}
                            </option>
                        ))}
                    </select>
                </div>
            <input
                placeholder="Adresa completa"
                type="text"
                className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                id="address"
                name="address"
                required
            />
            <div className="mb-1 sm:mb-2">
                <label
                    htmlFor="package"
                    className="inline-block mb-1 font-medium"
                >
                    Pachet de Scolarizare
                </label>
                <select
                    id="package"
                    className="flex-grow w-full h-12 px-4 mb-2 transition duration-200 bg-white border border-gray-300 rounded shadow-sm appearance-none focus:border-deep-purple-accent-400 focus:outline-none focus:shadow-outline"
                    name="package"
                    onChange={(e: any) => setPachet(e.target.value)}
                    defaultValue="Alege PACHETUL"
                    required
                >
                    <option value="">Alege PACHETUL</option>
                    <option value="CU DE TOATE - 2699 Lei">
                        CU DE TOATE - 2699 Lei
                    </option>
                    <option value="Cutie AUTOMATĂ - 2899 Lei">
                        Cutie AUTOMATĂ - 2899 Lei
                    </option>
                    <option value="Standard - 2499 Lei">
                        Standard - 2499 Lei
                    </option>
                </select>
            </div>
            <div className="mb-1 sm:mb-2">
                <label
                    htmlFor="privacyPolicy"
                    className="inline-flex items-center"
                >
                    <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                        id="privacyPolicy"
                        name="privacyPolicy"
                        required
                    />
                    <span className="ml-2 text-gray-700 text-sm">
                        Sunt de acord cu <a href="/politica-de-confidentialitate" className="font-bold text-deep-purple-accent-400">Politica de Confidențialitate</a>.
                    </span>
                </label>
                <label
                    htmlFor="termsAndConditions"
                    className="inline-flex items-center"
                >
                    <input
                        type="checkbox"
                        className="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                        id="termsAndConditions"
                        name="termsAndConditions"
                        required
                    />
                    <span className="ml-2 text-gray-700 text-sm">
                        Sunt de acord cu <button onClick={()=>{window.open('/Termeni-si-Conditii.pdf', '_blank');}} className="font-bold text-deep-purple-accent-400">Termenii si Condițiile</button>.
                    </span>
                </label>
            </div>
            <div className="mt-4 mb-2 sm:mb-4">
                <button
                    type="submit"
                    className="inline-flex items-center justify-center w-full h-12 px-6 font-medium tracking-wide text-white transition duration-200 rounded shadow-md bg-deep-purple-accent-400 hover:bg-deep-purple-accent-700 focus:shadow-outline focus:outline-none"
                >
                    Cumpără Pachetul
                </button>
            </div>
            {pachet != null && (
                <p className="text-xs text-gray-600 sm:text-sm">
                    Pentru a vă înregistra online și a achiziționa pachetul{" "}
                    <span className="font-bold">{pachet}</span>, veți fi
                    redirecționat către pagina de plată, pentru a achita un
                    avans în valoare de 100 de lei.
                </p>
            )}
            {selectedCounty && selectedCounty != "BUCUREȘTI" && (
                <Alert
                    title="ATENȚIE!"
                    text={`Ai selectat județul ${selectedCounty}. Școala de Șoferi BUZZ desfășoară ore doar în București! Dacă nu locuiești în București, îți recomandăm să abandonezi procedura de înscriere online!`}
                />
            )}
        </form>
    );
};
